<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useFarewellController } from './controller';
import type { FarewellScreenProps } from './types';

const props = defineProps<FarewellScreenProps>();
const controller = useFarewellController(props);
const { t } = useI18n();
</script>

<template>
  <section class="screen farewell-screen" data-testid="screen-farewell">
    <div class="content reveal" style="--reveal-order: 0">
      <h1 class="t-display">{{ t('farewell.title') }}</h1>
      <img :src="controller.logoUrl" alt="ENTR VR Museum" />
    </div>
  </section>
</template>

<style scoped>
.content {
  position: absolute;
  top: 660px;
  left: 120px;
  right: 120px;
  display: grid;
  gap: 120px;
  justify-items: center;
  text-align: center;
}

h1 {
  max-width: none;
  font-size: 60px;
  white-space: nowrap;
}

img {
  width: 620px;
  height: auto;
}
</style>
